import { useCallback, useContext } from 'react';
import { UIVersionContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import useV1HasAccess from './useV1HasAccess';
import useV2HasAccess from './useV2HasAccess';
import useV3HasAccess from './useV3HasAccess';

// Note: This should be used after the ContentProvider in the SplashScreen
const useHasAccess = () => {
  const { uiVersion } = useContext(UIVersionContext);
  const v1HasAccess = useV1HasAccess();
  const v2HasAccess = useV2HasAccess();
  const v3HasAccess = useV3HasAccess();

  const hasAccess = useCallback(
    ({
      access,
      resource,
      type,
      typeId,
    }: {
      // @deprecated Only used for the v1 UI
      access?: ResourceAccess;
      resource:
        | Resource
        | DashboardType
        | ReportType
        | GeneralGoal
        | Scorecards.Scorecard
        | PerformanceBoardTypes.Board
        | Board;
      type:
        | 'targetsApp'
        | 'entity'
        | 'dashboard'
        | 'report'
        | 'wallboard'
        | 'workspace'
        | 'goal'
        | 'scorecard'
        | 'board';
      typeId: string;
    }): boolean => {
      if (uiVersion === 'v1' || uiVersion === 'wallboard') {
        return !!v1HasAccess({ access, resource });
      }

      if (uiVersion === 'v2' || uiVersion === 'v2 - simplified') {
        return v2HasAccess({ type, typeId });
      }

      if (uiVersion === 'v3') {
        if (
          'v3Access' in resource &&
          (type === 'report' ||
            type === 'goal' ||
            type === 'dashboard' ||
            type === 'scorecard' ||
            type === 'board')
        ) {
          return v3HasAccess({
            type,
            typeId,
            resource,
          });
        }

        if (type === 'entity') {
          return true;
        }

        return false;
      }

      return false;
    },
    [uiVersion, v3HasAccess, v1HasAccess, v2HasAccess],
  );

  return hasAccess;
};

export default useHasAccess;
